import {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '_metronic/helpers'
import split from 'lodash/split'

type Props = {
  message: any
  show: boolean
  onClose: any
  title: string
}

const MessageDialog: FC<Props> = ({message, show, onClose, title}) => {
  return (
    <Modal
      size='lg'
      id='kt_modal_create_app'
      aria-hidden='true'
      dialogClassName='h-auto'
      show={show}
      onHide={onClose}
      centered
    >
      <div className='modal-header d-flex'>
        <h5 className='modal-title'>{title}</h5>
        <div className='btn btn-icon btn-sm ' data-kt-menu-dismiss='true' onClick={onClose}>
          <KTSVG
            className='svg-icon-2 rounded-1 border border-primary svg-icon-primary'
            path='/media/icons/duotune/arrows/arr061.svg'
          />
        </div>
      </div>
      <div className='modal-body align-items-center'>{getShippingComplianceMessage(message)} </div>
    </Modal>
  )
}

export default MessageDialog

const getShippingComplianceMessage = (message: any) => {
  let messages = split(message, '\n')
  messages.splice(0, 1)

  if (messages.length) {
    return (
      <div className='mx-3'>
        <div className='fs-4 fw-bolder text-dark pb-4'>
          <u>Non Compliance Messages</u>
        </div>
        {messages.map((message: any, index: number) => {
          return (
            <div className=' align-items-center fs-5 pb-3'>
              <span>{`${index + 1}. ${message}`}</span>
            </div>
          )
        })}
      </div>
    )
  }
  if (message && messages.length === 0) {
    return (
      <div className='mx-3'>
        <div className='align-items-center fs-5 pb-3'>{message}</div>
      </div>
    )
  }
  return (
    <div className='d-flex justify-content-center text-muted p-10 m-10'>No messages found !</div>
  )
}
